import {escapeHtml, type Tokens} from '@time-webkit/marked';

import {getScheme} from 'utils/url';

import RemoveMarkdown from './remove_markdown';

export default class LinkOnlyRenderer extends RemoveMarkdown {
    public link(token: Tokens.Link) {
        const {href, title} = token;
        const text = super.link(token);

        let outHref = escapeHtml(href);

        if (!getScheme(href)) {
            outHref = `http://${outHref}`;
        }

        let output = `<a class="theme markdown__link" href="${outHref}" target="_blank"`;

        if (title) {
            output += ' title="' + escapeHtml(title) + '"';
        }

        // remove any links added to the text by hashtag or mention parsing since they'll break this link
        output += '>' + text.replace(/<\/?a[^>]*>/g, '') + '</a>';

        return output;
    }
}
